import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { AuthOptions, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import UserCognitoService from './services/controllers/user/UserCognitoService';

const { VITE_AWS_APPSYNC_GRAPHQL_ENDPOINT, VITE_AWS_REGION } = import.meta.env;

const url = VITE_AWS_APPSYNC_GRAPHQL_ENDPOINT || 'https://fl7jwpicsbggrk2xxdakrpicsu.appsync-api.eu-west-2.amazonaws.com/graphql';
const region = VITE_AWS_REGION || 'eu-west-2';

const { location } = window;
const query = new URLSearchParams(location.search);

const token = query.get('token');

const auth: AuthOptions = {
  type: 'AMAZON_COGNITO_USER_POOLS',
  jwtToken: UserCognitoService.cognitoUser?.getSignInUserSession()?.getAccessToken().getJwtToken() || token || '',
};

const httpLink = new HttpLink({ uri: url });

// const errorLink = onError(({ graphQLErrors, networkError }) => {
//   if (graphQLErrors)
//     graphQLErrors.forEach(({ message, locations, path }) =>
//       console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`),
//     );
//   if (networkError) console.error(`[Network error]: ${networkError}`);
// });

const link = ApolloLink.from([
  // errorLink,
  createAuthLink({ url, region, auth }),
  createSubscriptionHandshakeLink({ url, region, auth }, httpLink),
]);

export const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({
    resultCacheMaxSize: 100,
    typePolicies: {
      BookNew: {
        fields: {
          pages: {
            merge(existing, incoming) {
              const existingPages = existing?.length ? existing : [];
              const incomingPages = incoming?.length ? incoming : [];
              const ids = incomingPages.map((p: any) => p.id);
              return [...existingPages.filter((p: any) => !ids.includes(p.id)), ...incomingPages];
            },
          },
        },
      },
    },
  }),
  connectToDevTools: import.meta.env.DEV,
});
